import { Injectable, Injector } from '@angular/core';
import { AbstractGitFactoryService } from '@y42/feature/git/state';
import { UiModelingGitService } from './ui-modeling-git.service';

@Injectable({ providedIn: 'root' })
export class UiModelingGitFactoryService extends AbstractGitFactoryService<UiModelingGitService> {
  constructor(injector: Injector) {
    super({
      injector,
      gitService: UiModelingGitService,
    });
  }
}
